export default `:root {
    color-scheme: light dark;
    --_ui5-light-scheme: var(--_ui5-f2d95f8);
    --_ui5-dark-scheme:  ;
    --sapThemeMetaData-Base-baseLib: {"Path": "Base.baseLib.sap_horizon_hcw.css_variables","PathPattern": "/%frameworkId%/%libId%/%themeId%/%fileId%.css","Extends": ["sap_horizon_hcb","sap_horizon","baseTheme"],"Tags": ["Fiori_3","HighContrast","LightColorScheme"],"FallbackThemeId": "sap_fiori_3_hcw","Engine":{"Name": "theming-engine","Version": "17.0.3"},"Version":{"Build": "11.34.1.20260225145029","Source": "11.34.1"}};
    --sapBrandColor: light-dark(#e97624, #795100);
    --sapHighlightColor: light-dark(#e97624, #795100);
    --sapBaseColor: light-dark(#fff, #000);
    --sapShellColor: light-dark(#fff, #000);
    --sapBackgroundColor: light-dark(#fff, #000);
    --sapFontFamily: "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontSize: .875rem;
    --sapTextColor: light-dark(#000, #fff);
    --sapLinkColor: light-dark(#000, #fff);
    --sapCompanyLogo: none;
    --sapFavicon: none;
    --sapBackgroundImage: none;
    --sapBackgroundImageOpacity: 1;
    --sapBackgroundImageRepeat: false;
    --sapSelectedColor: light-dark(#5c93ff, #0f5c93);
    --sapHoverColor: light-dark(#e97624, #795100);
    --sapActiveColor: light-dark(#e97624, #795100);
    --sapTitleColor: light-dark(#000, #fff);
    --sapNegativeColor: light-dark(#ab0000, #ff5e5e);
    --sapCriticalColor: light-dark(#5c5c00, #ffab1d);
    --sapPositiveColor: light-dark(#006362, #99cc99);
    --sapInformativeColor: light-dark(#000, #fff);
    --sapNeutralColor: light-dark(#000, #fff);
    --sapNegativeElementColor: light-dark(#ab0000, #ff5e5e);
    --sapCriticalElementColor: light-dark(#5c5c00, #ffab1d);
    --sapPositiveElementColor: light-dark(#006362, #99cc99);
    --sapInformativeElementColor: light-dark(#000, #fff);
    --sapNeutralElementColor: light-dark(#000, #fff);
    --sapNegativeTextColor: light-dark(#ab0000, #ff5e5e);
    --sapCriticalTextColor: light-dark(#5c5c00, #ffab1d);
    --sapPositiveTextColor: light-dark(#006362, #99cc99);
    --sapInformativeTextColor: light-dark(#000, #fff);
    --sapNeutralTextColor: light-dark(#000, #fff);
    --sapErrorColor: light-dark(#ab0000, #ff5e5e);
    --sapWarningColor: light-dark(#5c5c00, #ffab1d);
    --sapSuccessColor: light-dark(#006362, #99cc99);
    --sapInformationColor: light-dark(#000, #fff);
    --sapErrorBackground: light-dark(#fff, #000);
    --sapWarningBackground: light-dark(#fff, #000);
    --sapSuccessBackground: light-dark(#fff, #000);
    --sapInformationBackground: light-dark(#fff, #000);
    --sapNeutralBackground: light-dark(#fff, #000);
    --sapErrorBorderColor: light-dark(#ab0000, #ff5e5e);
    --sapWarningBorderColor: light-dark(#5c5c00, #ffab1d);
    --sapSuccessBorderColor: light-dark(#006362, #99cc99);
    --sapInformationBorderColor: light-dark(#000, #fff);
    --sapNeutralBorderColor: light-dark(#000, #fff);
    --sapElement_LineHeight: 2.75rem;
    --sapElement_Height: 2.25rem;
    --sapElement_BorderWidth: .0625rem;
    --sapElement_BorderCornerRadius: .25rem;
    --sapElement_Compact_LineHeight: 2rem;
    --sapElement_Compact_Height: 1.625rem;
    --sapElement_Condensed_LineHeight: 1.5rem;
    --sapElement_Condensed_Height: 1.375rem;
    --sapContent_LineHeight: 1.5;
    --sapContent_IconHeight: 1rem;
    --sapContent_IconColor: light-dark(#000, #fff);
    --sapContent_ContrastIconColor: light-dark(#000, #fff);
    --sapContent_NonInteractiveIconColor: light-dark(#000, #fff);
    --sapContent_MarkerIconColor: light-dark(#000, #fff);
    --sapContent_MarkerTextColor: light-dark(#000, #fff);
    --sapContent_MeasureIndicatorColor: light-dark(#000, #fff);
    --sapContent_Selected_MeasureIndicatorColor: light-dark(#000, #fff);
    --sapContent_Placeholderloading_Background: light-dark(#888, #666);
    --sapContent_Placeholderloading_Gradient: var(--_ui5-light-scheme, linear-gradient(to right, #888 0%, #888 35%, #585858 50%, #888 65%, #888 100%)) var(--_ui5-dark-scheme, linear-gradient(to right, #666 0%, #666 35%, #999 50%, #666 65%, #666 100%));
    --sapContent_ImagePlaceholderBackground: light-dark(#fff, #000);
    --sapContent_ImagePlaceholderForegroundColor: light-dark(#000, #fff);
    --sapContent_RatedColor: light-dark(#000, #fff);
    --sapContent_UnratedColor: light-dark(#585858, #999);
    --sapContent_BusyColor: light-dark(#000, #fff);
    --sapContent_FocusColor: light-dark(#000, #fff);
    --sapContent_FocusStyle: dotted;
    --sapContent_FocusWidth: .125rem;
    --sapContent_ContrastFocusColor: light-dark(#000, #fff);
    --sapContent_ShadowColor: light-dark(#000, #fff);
    --sapContent_ContrastShadowColor: light-dark(#000, #fff);
    --sapContent_Shadow0: var(--_ui5-light-scheme, 0 0 0 .0625rem #000) var(--_ui5-dark-scheme, 0 0 0 .0625rem #fff);
    --sapContent_Shadow1: var(--_ui5-light-scheme, 0 0 1rem 0 rgba(0,0,0,.5), 0 0 0 .125rem #000) var(--_ui5-dark-scheme, 0 0 1rem 0 rgba(255,255,255,.5), 0 0 0 .125rem #fff);
    --sapContent_Shadow2: var(--_ui5-light-scheme, 0 .25rem 2rem 0 rgba(0,0,0,.6), 0 0 0 .125rem #000) var(--_ui5-dark-scheme, 0 .25rem 2rem 0 rgba(255,255,255,.6), 0 0 0 .125rem #fff);
    --sapContent_Shadow3: var(--_ui5-light-scheme, 0 .625rem 4rem 0 rgba(0,0,0,.8), 0 0 0 .125rem #000) var(--_ui5-dark-scheme, 0 .625rem 4rem 0 rgba(255,255,255,.8), 0 0 0 .125rem #fff);
    --sapContent_TextShadow: var(--_ui5-light-scheme, -.0625rem 0 #fff, 0 .0625rem #fff, .0625rem 0 #fff, 0 -.0625rem #fff) var(--_ui5-dark-scheme, -.0625rem 0 #000, 0 .0625rem #000, .0625rem 0 #000, 0 -.0625rem #000);
    --sapContent_ContrastTextShadow: none;
    --sapContent_HeaderShadow: var(--_ui5-light-scheme, inset 0 -.125rem #000) var(--_ui5-dark-scheme, inset 0 -.125rem #fff);
    --sapContent_Interaction_Shadow: none;
    --sapContent_Selected_Shadow: none;
    --sapContent_Negative_Shadow: none;
    --sapContent_Critical_Shadow: none;
    --sapContent_Positive_Shadow: none;
    --sapContent_Informative_Shadow: none;
    --sapContent_Neutral_Shadow: none;
    --sapContent_SearchHighlightColor: light-dark(#e97624, #795100);
    --sapContent_HelpColor: light-dark(#006800, #03ae03);
    --sapContent_LabelColor: light-dark(#000, #fff);
    --sapContent_MonospaceFontFamily: "72Mono", "72Monofull", lucida console, monospace;
    --sapContent_MonospaceBoldFontFamily: "72Mono-Bold", "72Mono-Boldfull", lucida console, monospace;
    --sapContent_IconFontFamily: "SAP-icons";
    --sapContent_DisabledTextColor: light-dark(#888, #666);
    --sapContent_DisabledOpacity: .4;
    --sapContent_ContrastTextThreshold: .5;
    --sapContent_ContrastTextColor: light-dark(#000, #fff);
    --sapContent_ForegroundColor: light-dark(#fff, #000);
    --sapContent_ForegroundBorderColor: light-dark(#000, #fff);
    --sapContent_ForegroundTextColor: light-dark(#000, #fff);
    --sapContent_BadgeBackground: light-dark(#000, #fff);
    --sapContent_BadgeTextColor: light-dark(#fff, #000);
    --sapContent_BadgeBorderColor: light-dark(#fff, #000);
    --sapContent_DragAndDropActiveColor: light-dark(#006800, #03ae03);
    --sapContent_Selected_TextColor: light-dark(#000, #fff);
    --sapContent_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapContent_Selected_Hover_Background: light-dark(#e97624, #795100);
    --sapContent_Selected_ForegroundColor: light-dark(#000, #fff);
    --sapContent_ForcedColorAdjust: none;
    --sapContent_Lite_Shadow: var(--_ui5-light-scheme, 0 0 1rem 0 rgba(0,0,0,.5), 0 0 0 .125rem #000) var(--_ui5-dark-scheme, 0 0 1rem 0 rgba(255,255,255,.5), 0 0 0 .125rem #fff);
    --sapContent_Illustrative_Color1: #9b015d;
    --sapContent_Illustrative_Color2: light-dark(#56bdff, #4d82b8);
    --sapContent_Illustrative_Color3: #ff7f4c;
    --sapContent_Illustrative_Color4: light-dark(#00144a, #688fb7);
    --sapContent_Illustrative_Color5: light-dark(#a9b4be, #fff);
    --sapContent_Illustrative_Color6: light-dark(#d5dadd, #818f98);
    --sapContent_Illustrative_Color7: light-dark(#dbf1ff, #101619);
    --sapContent_Illustrative_Color8: light-dark(#fff, #d5dadd);
    --sapContent_Illustrative_Color9: #0899a7;
    --sapContent_Illustrative_Color10: light-dark(#dbf1ff, #ebf8ff);
    --sapContent_Illustrative_Color11: light-dark(#df1278, #fa4f96);
    --sapContent_Illustrative_Color12: #00a800;
    --sapContent_Illustrative_Color13: light-dark(#0070f2, #3b5b7c);
    --sapContent_Illustrative_Color14: light-dark(#0040b0, #2a4259);
    --sapContent_Illustrative_Color15: #c35500;
    --sapContent_Illustrative_Color16: #8d2a00;
    --sapContent_Illustrative_Color17: #046c7c;
    --sapContent_Illustrative_Color18: light-dark(#bce5ff, #2a4259);
    --sapContent_Illustrative_Color19: light-dark(#a3dbff, #324e6b);
    --sapContent_Illustrative_Color20: light-dark(#89d1ff, #222f3b);
    --sapContent_Illustrative_Color21: light-dark(#1b90ff, #101619);
    --sapContent_Illustrative_Color22: #00144a;
    --sapContent_Illustrative_Color23: #d20a0a;
    --sapContent_Illustrative_Color24: light-dark(#ffb2d2, #d094b0);
    --sapContent_Illustrative_Color25: light-dark(#ffeaf4, #d0c1cb);
    --sapContent_Illustrative_Color26: light-dark(#ffdf72, #d0b863);
    --sapContent_Illustrative_Color27: light-dark(#fff8d6, #d0cdb3);
    --sapContent_Illustrative_Color28: #a93e00;
    --sapContent_Illustrative_Color29: #450b00;
    --sapContent_Illustrative_Color30: #340800;
    --sapContent_Illustrative_Color31: #ffab92;
    --sapContent_Space_S: 1rem;
    --sapContent_Space_M: 2rem;
    --sapContent_Space_L: 2rem;
    --sapContent_Space_XL: 3rem;
    --sapContent_Space_Tiny: .5rem;
    --sapContent_Space_Small: 1rem;
    --sapContent_Space_Medium: 2rem;
    --sapContent_Space_Large: 3rem;
    --sapContent_Margin_Tiny: 0 0 1rem;
    --sapContent_Margin_Small: 1rem;
    --sapContent_Margin_Medium: 1rem 2rem;
    --sapContent_Margin_Large: 1rem 3rem;
    --sapContent_Margin_S: 0 0 1rem;
    --sapContent_Margin_M: 1rem;
    --sapContent_Margin_L: 1rem 2rem;
    --sapContent_Margin_XL: 1rem 3rem;
    --sapContent_Padding_S: 0rem;
    --sapContent_Padding_M: 2rem;
    --sapContent_Padding_L: 2rem;
    --sapContent_Padding_XL: 3rem;
    --sapContent_Gap: 1rem;
    --sapContent_Success_HeaderShadow: var(--_ui5-light-scheme, inset 0 -.125rem #006362) var(--_ui5-dark-scheme, inset 0 -.125rem #99cc99);
    --sapContent_Warning_HeaderShadow: var(--_ui5-light-scheme, inset 0 -.125rem #5c5c00) var(--_ui5-dark-scheme, inset 0 -.125rem #ffab1d);
    --sapContent_Error_HeaderShadow: var(--_ui5-light-scheme, inset 0 -.125rem #ab0000) var(--_ui5-dark-scheme, inset 0 -.125rem #ff5e5e);
    --sapContent_Information_HeaderShadow: var(--_ui5-light-scheme, inset 0 -.125rem #000) var(--_ui5-dark-scheme, inset 0 -.125rem #fff);
    --sapFontLightFamily: "72-Light", "72-Lightfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontBoldFamily: "72-Bold", "72-Boldfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontSemiboldFamily: "72-Semibold", "72-Semiboldfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontSemiboldDuplexFamily: "72-SemiboldDuplex", "72-SemiboldDuplexfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontBlackFamily: "72Black", "72Blackfull","72", "72full", Arial, Helvetica, sans-serif;
    --sapFontHeaderFamily: "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontSmallSize: .75rem;
    --sapFontLargeSize: 1rem;
    --sapFontHeader1Size: 3rem;
    --sapFontHeader2Size: 2rem;
    --sapFontHeader3Size: 1.5rem;
    --sapFontHeader4Size: 1.25rem;
    --sapFontHeader5Size: 1rem;
    --sapFontHeader6Size: .875rem;
    --sapLink_TextDecoration: underline;
    --sapLink_Hover_Color: light-dark(#000, #fff);
    --sapLink_Hover_TextDecoration: none;
    --sapLink_Active_Color: light-dark(#000, #fff);
    --sapLink_Active_TextDecoration: underline;
    --sapLink_Visited_Color: light-dark(#000, #fff);
    --sapLink_InvertedColor: light-dark(#000, #fff);
    --sapLink_SubtleColor: light-dark(#000, #fff);
    --sapShell_Background: light-dark(#fff, #000);
    --sapShell_BackgroundImage: var(--_ui5-light-scheme, linear-gradient(to bottom, #fff, #fff)) var(--_ui5-dark-scheme, linear-gradient(to bottom, #000, #000));
    --sapShell_BackgroundImageOpacity: 1;
    --sapShell_BackgroundImageRepeat: false;
    --sapShell_BorderColor: light-dark(#000, #fff);
    --sapShell_TextColor: light-dark(#000, #fff);
    --sapShell_InteractiveBackground: light-dark(#fff, #000);
    --sapShell_InteractiveTextColor: light-dark(#000, #fff);
    --sapShell_InteractiveBorderColor: light-dark(#000, #fff);
    --sapShell_GroupTitleTextColor: light-dark(#000, #fff);
    --sapShell_GroupTitleTextShadow: var(--_ui5-light-scheme, -.0625rem 0 #fff, 0 .0625rem #fff, .0625rem 0 #fff, 0 -.0625rem #fff) var(--_ui5-dark-scheme, -.0625rem 0 #000, 0 .0625rem #000, .0625rem 0 #000, 0 -.0625rem #000);
    --sapShell_Hover_Background: light-dark(#e97624, #795100);
    --sapShell_Active_Background: light-dark(#e97624, #795100);
    --sapShell_Active_TextColor: light-dark(#000, #fff);
    --sapShell_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapShell_Selected_TextColor: light-dark(#000, #fff);
    --sapShell_Selected_Hover_Background: light-dark(#e97624, #795100);
    --sapShell_Favicon: none;
    --sapShell_Navigation_Background: light-dark(#fff, #000);
    --sapShell_Navigation_Hover_Background: light-dark(#e97624, #795100);
    --sapShell_Navigation_SelectedColor: light-dark(#000, #fff);
    --sapShell_Navigation_Selected_TextColor: light-dark(#000, #fff);
    --sapShell_Navigation_TextColor: light-dark(#000, #fff);
    --sapShell_Navigation_Active_TextColor: light-dark(#000, #fff);
    --sapShell_Navigation_Active_Background: light-dark(#e97624, #795100);
    --sapShell_Shadow: var(--_ui5-light-scheme, 0 .125rem 0 0 #000) var(--_ui5-dark-scheme, 0 .125rem 0 0 #fff);
    --sapShell_NegativeColor: light-dark(#ab0000, #ff5e5e);
    --sapShell_CriticalColor: light-dark(#5c5c00, #ffab1d);
    --sapShell_PositiveColor: light-dark(#006362, #99cc99);
    --sapShell_InformativeColor: light-dark(#000, #fff);
    --sapShell_NeutralColor: light-dark(#000, #fff);
    --sapShell_Assistant_ForegroundColor: light-dark(#000, #fff);
    --sapShell_SubBrand_TextColor: light-dark(#000, #fff);
    --sapShell_Category_1_Background: light-dark(#fff, #000);
    --sapShell_Category_1_BorderColor: light-dark(#004ccb, #6bd3ff);
    --sapShell_Category_1_TextColor: light-dark(#000, #fff);
    --sapShell_Category_1_TextShadow: none;
    --sapShell_Category_2_Background: light-dark(#fff, #000);
    --sapShell_Category_2_BorderColor: light-dark(#973333, #db9292);
    --sapShell_Category_2_TextColor: light-dark(#000, #fff);
    --sapShell_Category_2_TextShadow: none;
    --sapShell_Category_3_Background: light-dark(#fff, #000);
    --sapShell_Category_3_BorderColor: light-dark(#5f5800, #ffc847);
    --sapShell_Category_3_TextColor: light-dark(#000, #fff);
    --sapShell_Category_3_TextShadow: none;
    --sapShell_Category_4_Background: light-dark(#fff, #000);
    --sapShell_Category_4_BorderColor: light-dark(#6c3d62, #bb86b0);
    --sapShell_Category_4_TextColor: light-dark(#000, #fff);
    --sapShell_Category_4_TextShadow: none;
    --sapShell_Category_5_Background: light-dark(#fff, #000);
    --sapShell_Category_5_BorderColor: light-dark(#734f00, #cdaf9d);
    --sapShell_Category_5_TextColor: light-dark(#000, #fff);
    --sapShell_Category_5_TextShadow: none;
    --sapShell_Category_6_Background: light-dark(#fff, #000);
    --sapShell_Category_6_BorderColor: light-dark(#105b5b, #7fc6c6);
    --sapShell_Category_6_TextColor: light-dark(#000, #fff);
    --sapShell_Category_6_TextShadow: none;
    --sapShell_Category_7_Background: light-dark(#fff, #000);
    --sapShell_Category_7_BorderColor: light-dark(#961d7c, #e269c9);
    --sapShell_Category_7_TextColor: light-dark(#000, #fff);
    --sapShell_Category_7_TextShadow: none;
    --sapShell_Category_8_Background: light-dark(#fff, #000);
    --sapShell_Category_8_BorderColor: light-dark(#26340b, #b2e484);
    --sapShell_Category_8_TextColor: light-dark(#000, #fff);
    --sapShell_Category_8_TextShadow: none;
    --sapShell_Category_9_Background: light-dark(#fff, #000);
    --sapShell_Category_9_BorderColor: light-dark(#002a86, #4db1ff);
    --sapShell_Category_9_TextColor: light-dark(#000, #fff);
    --sapShell_Category_9_TextShadow: none;
    --sapShell_Category_10_Background: light-dark(#fff, #000);
    --sapShell_Category_10_BorderColor: light-dark(#47596c, #b0bcc5);
    --sapShell_Category_10_TextColor: light-dark(#000, #fff);
    --sapShell_Category_10_TextShadow: none;
    --sapShell_Category_11_Background: light-dark(#fff, #000);
    --sapShell_Category_11_BorderColor: light-dark(#af080b, #ff8787);
    --sapShell_Category_11_TextColor: light-dark(#000, #fff);
    --sapShell_Category_11_TextShadow: none;
    --sapShell_Category_12_Background: light-dark(#fff, #000);
    --sapShell_Category_12_BorderColor: light-dark(#7000e0, #d3b6ff);
    --sapShell_Category_12_TextColor: light-dark(#000, #fff);
    --sapShell_Category_12_TextShadow: none;
    --sapShell_Category_13_Background: light-dark(#fff, #000);
    --sapShell_Category_13_BorderColor: light-dark(#580440, #fdcef0);
    --sapShell_Category_13_TextColor: light-dark(#000, #fff);
    --sapShell_Category_13_TextShadow: none;
    --sapShell_Category_14_Background: light-dark(#fff, #000);
    --sapShell_Category_14_BorderColor: light-dark(#035663, #a4eeee);
    --sapShell_Category_14_TextColor: light-dark(#000, #fff);
    --sapShell_Category_14_TextShadow: none;
    --sapShell_Category_15_Background: light-dark(#fff, #000);
    --sapShell_Category_15_BorderColor: light-dark(#223548, #eaecee);
    --sapShell_Category_15_TextColor: light-dark(#000, #fff);
    --sapShell_Category_15_TextShadow: none;
    --sapShell_Category_16_Background: light-dark(#fff, #000);
    --sapShell_Category_16_BorderColor: light-dark(#1e592f, #b2e484);
    --sapShell_Category_16_TextColor: light-dark(#000, #fff);
    --sapShell_Category_16_TextShadow: none;
    --sapShell_Space_S: .5rem;
    --sapShell_Space_M: 2rem;
    --sapShell_Space_L: 2rem;
    --sapShell_Space_XL: 3rem;
    --sapShell_Gap_S: .5rem;
    --sapShell_Gap_M: 1rem;
    --sapShell_Gap_L: 1rem;
    --sapShell_Gap_XL: 1rem;
    --sapShell_GroupGap_S: 2rem;
    --sapShell_GroupGap_M: 3rem;
    --sapShell_GroupGap_L: 3rem;
    --sapShell_GroupGap_XL: 3rem;
    --sapAssistant_Color1: light-dark(#000, #fff);
    --sapAssistant_Color2: light-dark(#000, #fff);
    --sapAssistant_BackgroundGradient: var(--_ui5-light-scheme, linear-gradient(#fff, #fff)) var(--_ui5-dark-scheme, linear-gradient(#000, #000));
    --sapAssistant_Background: light-dark(#fff, #000);
    --sapAssistant_BorderColor: light-dark(#000, #fff);
    --sapAssistant_TextColor: light-dark(#000, #fff);
    --sapAssistant_Hover_Background: light-dark(#e97624, #795100);
    --sapAssistant_Hover_BorderColor: light-dark(#000, #fff);
    --sapAssistant_Hover_TextColor: light-dark(#000, #fff);
    --sapAssistant_Active_Background: light-dark(#e97624, #795100);
    --sapAssistant_Active_BorderColor: light-dark(#000, #fff);
    --sapAssistant_Active_TextColor: light-dark(#000, #fff);
    --sapAssistant_Question_Background: light-dark(#fff, #000);
    --sapAssistant_Question_BorderColor: light-dark(#000, #fff);
    --sapAssistant_Question_TextColor: light-dark(#000, #fff);
    --sapAssistant_Answer_Background: light-dark(#b3b3b3, #585858);
    --sapAssistant_Answer_BorderColor: light-dark(#000, #fff);
    --sapAssistant_Answer_TextColor: light-dark(#000, #fff);
    --sapAvatar_1_Background: light-dark(#fff, #000);
    --sapAvatar_1_BorderColor: light-dark(#000, #fff);
    --sapAvatar_1_TextColor: light-dark(#000, #fff);
    --sapAvatar_1_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_2_Background: light-dark(#fff, #000);
    --sapAvatar_2_BorderColor: light-dark(#000, #fff);
    --sapAvatar_2_TextColor: light-dark(#000, #fff);
    --sapAvatar_2_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_3_Background: light-dark(#fff, #000);
    --sapAvatar_3_BorderColor: light-dark(#000, #fff);
    --sapAvatar_3_TextColor: light-dark(#000, #fff);
    --sapAvatar_3_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_4_Background: light-dark(#fff, #000);
    --sapAvatar_4_BorderColor: light-dark(#000, #fff);
    --sapAvatar_4_TextColor: light-dark(#000, #fff);
    --sapAvatar_4_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_5_Background: light-dark(#fff, #000);
    --sapAvatar_5_BorderColor: light-dark(#000, #fff);
    --sapAvatar_5_TextColor: light-dark(#000, #fff);
    --sapAvatar_5_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_6_Background: light-dark(#fff, #000);
    --sapAvatar_6_BorderColor: light-dark(#000, #fff);
    --sapAvatar_6_TextColor: light-dark(#000, #fff);
    --sapAvatar_6_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_7_Background: light-dark(#fff, #000);
    --sapAvatar_7_BorderColor: light-dark(#000, #fff);
    --sapAvatar_7_TextColor: light-dark(#000, #fff);
    --sapAvatar_7_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_8_Background: light-dark(#fff, #000);
    --sapAvatar_8_BorderColor: light-dark(#000, #fff);
    --sapAvatar_8_TextColor: light-dark(#000, #fff);
    --sapAvatar_8_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_9_Background: light-dark(#fff, #000);
    --sapAvatar_9_BorderColor: light-dark(#000, #fff);
    --sapAvatar_9_TextColor: light-dark(#000, #fff);
    --sapAvatar_9_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_10_Background: light-dark(#fff, #000);
    --sapAvatar_10_BorderColor: light-dark(#000, #fff);
    --sapAvatar_10_TextColor: light-dark(#000, #fff);
    --sapAvatar_10_Hover_Background: light-dark(#e97624, #795100);
    --sapAvatar_Lite_BorderColor: light-dark(#000, #fff);
    --sapAvatar_Lite_Background: light-dark(#fff, #000);
    --sapAvatar_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Background: light-dark(#fff, #000);
    --sapButton_BorderColor: light-dark(#000, #fff);
    --sapButton_BorderWidth: .0625rem;
    --sapButton_BorderCornerRadius: .375rem;
    --sapButton_TextColor: light-dark(#000, #fff);
    --sapButton_FontFamily: "72", "72full", Arial, Helvetica, sans-serif;
    --sapButton_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_IconColor: light-dark(#000, #fff);
    --sapButton_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Emphasized_Background: light-dark(#fff, #000);
    --sapButton_Emphasized_BorderColor: light-dark(#000, #fff);
    --sapButton_Emphasized_BorderWidth: .125rem;
    --sapButton_Emphasized_TextColor: light-dark(#000, #fff);
    --sapButton_Emphasized_FontFamily: "72-Bold", "72-Boldfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapButton_Emphasized_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Emphasized_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Emphasized_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Emphasized_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Emphasized_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Emphasized_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Emphasized_TextShadow: transparent;
    --sapButton_Reject_Background: light-dark(#fff, #000);
    --sapButton_Reject_BorderColor: light-dark(#000, #fff);
    --sapButton_Reject_TextColor: light-dark(#000, #fff);
    --sapButton_Reject_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Reject_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Reject_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Reject_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Reject_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Reject_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Reject_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapButton_Reject_Selected_BorderColor: light-dark(#000, #fff);
    --sapButton_Reject_Selected_TextColor: light-dark(#000, #fff);
    --sapButton_Reject_Selected_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Reject_Selected_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Accept_Background: light-dark(#fff, #000);
    --sapButton_Accept_BorderColor: light-dark(#000, #fff);
    --sapButton_Accept_TextColor: light-dark(#000, #fff);
    --sapButton_Accept_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Accept_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Accept_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Accept_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Accept_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Accept_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Accept_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapButton_Accept_Selected_BorderColor: light-dark(#000, #fff);
    --sapButton_Accept_Selected_TextColor: light-dark(#000, #fff);
    --sapButton_Accept_Selected_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Accept_Selected_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Lite_Background: light-dark(#fff, #000);
    --sapButton_Lite_BorderColor: light-dark(#000, #fff);
    --sapButton_Lite_TextColor: light-dark(#000, #fff);
    --sapButton_Lite_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Lite_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Lite_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Lite_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Lite_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapButton_Selected_BorderColor: light-dark(#000, #fff);
    --sapButton_Selected_TextColor: light-dark(#000, #fff);
    --sapButton_Selected_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Selected_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Attention_Background: light-dark(#fff, #000);
    --sapButton_Attention_BorderColor: light-dark(#000, #fff);
    --sapButton_Attention_TextColor: light-dark(#000, #fff);
    --sapButton_Attention_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Attention_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Attention_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Attention_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Attention_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Attention_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Attention_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapButton_Attention_Selected_BorderColor: light-dark(#000, #fff);
    --sapButton_Attention_Selected_TextColor: light-dark(#000, #fff);
    --sapButton_Attention_Selected_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Attention_Selected_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Negative_Background: light-dark(#fff, #000);
    --sapButton_Negative_BorderColor: light-dark(#000, #fff);
    --sapButton_Negative_TextColor: light-dark(#000, #fff);
    --sapButton_Negative_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Negative_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Negative_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Negative_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Negative_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Negative_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Critical_Background: light-dark(#fff, #000);
    --sapButton_Critical_BorderColor: light-dark(#000, #fff);
    --sapButton_Critical_TextColor: light-dark(#000, #fff);
    --sapButton_Critical_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Critical_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Critical_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Critical_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Critical_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Critical_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Success_Background: light-dark(#fff, #000);
    --sapButton_Success_BorderColor: light-dark(#000, #fff);
    --sapButton_Success_TextColor: light-dark(#000, #fff);
    --sapButton_Success_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Success_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Success_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Success_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Success_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Success_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Information_Background: light-dark(#fff, #000);
    --sapButton_Information_BorderColor: light-dark(#000, #fff);
    --sapButton_Information_TextColor: light-dark(#000, #fff);
    --sapButton_Information_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Information_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Information_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Information_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Information_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Information_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Neutral_Background: light-dark(#fff, #000);
    --sapButton_Neutral_BorderColor: light-dark(#000, #fff);
    --sapButton_Neutral_TextColor: light-dark(#000, #fff);
    --sapButton_Neutral_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Neutral_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Neutral_Hover_TextColor: light-dark(#000, #fff);
    --sapButton_Neutral_Active_Background: light-dark(#e97624, #795100);
    --sapButton_Neutral_Active_BorderColor: light-dark(#000, #fff);
    --sapButton_Neutral_Active_TextColor: light-dark(#000, #fff);
    --sapButton_Track_Background: light-dark(#fff, #000);
    --sapButton_Track_BorderColor: light-dark(#000, #fff);
    --sapButton_Track_TextColor: light-dark(#000, #fff);
    --sapButton_Track_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Track_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Track_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapButton_Track_Selected_BorderColor: light-dark(#000, #fff);
    --sapButton_Track_Selected_TextColor: light-dark(#000, #fff);
    --sapButton_Track_Selected_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Track_Selected_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Handle_Background: light-dark(#fff, #000);
    --sapButton_Handle_BorderColor: light-dark(#000, #fff);
    --sapButton_Handle_TextColor: light-dark(#000, #fff);
    --sapButton_Handle_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Handle_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Handle_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapButton_Handle_Selected_BorderColor: light-dark(#000, #fff);
    --sapButton_Handle_Selected_TextColor: light-dark(#000, #fff);
    --sapButton_Handle_Selected_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Handle_Selected_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Track_Negative_Background: light-dark(#fff, #000);
    --sapButton_Track_Negative_BorderColor: light-dark(#ab0000, #ff5e5e);
    --sapButton_Track_Negative_TextColor: light-dark(#000, #fff);
    --sapButton_Track_Negative_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Track_Negative_Hover_BorderColor: light-dark(#ab0000, #ff5e5e);
    --sapButton_Handle_Negative_Background: light-dark(#fff, #000);
    --sapButton_Handle_Negative_BorderColor: light-dark(#ab0000, #ff5e5e);
    --sapButton_Handle_Negative_TextColor: light-dark(#000, #fff);
    --sapButton_Handle_Negative_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Handle_Negative_Hover_BorderColor: light-dark(#ab0000, #ff5e5e);
    --sapButton_Track_Positive_Background: light-dark(#fff, #000);
    --sapButton_Track_Positive_BorderColor: light-dark(#006362, #99cc99);
    --sapButton_Track_Positive_TextColor: light-dark(#000, #fff);
    --sapButton_Track_Positive_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Track_Positive_Hover_BorderColor: light-dark(#000, #fff);
    --sapButton_Handle_Positive_Background: light-dark(#fff, #000);
    --sapButton_Handle_Positive_BorderColor: light-dark(#006362, #99cc99);
    --sapButton_Handle_Positive_TextColor: light-dark(#000, #fff);
    --sapButton_Handle_Positive_Hover_Background: light-dark(#e97624, #795100);
    --sapButton_Handle_Positive_Hover_BorderColor: light-dark(#006362, #99cc99);
    --sapButton_TokenBackground: light-dark(#fff, #000);
    --sapButton_TokenBorderColor: light-dark(#000, #fff);
    --sapButton_TokenBorderCornerRadius: .25rem;
    --sapButton_Selected_TokenBorderWidth: 0;
    --sapButton_ReadOnly_TokenBackground: light-dark(#b3b3b3, #585858);
    --sapButton_Segment_BorderCornerRadius: 0;
    --sapField_Background: light-dark(#fff, #000);
    --sapField_BackgroundStyle: none;
    --sapField_TextColor: light-dark(#000, #fff);
    --sapField_PlaceholderTextColor: light-dark(#585858, #999);
    --sapField_BorderColor: light-dark(#000, #fff);
    --sapField_HelpBackground: light-dark(#fff, #000);
    --sapField_BorderWidth: .125rem;
    --sapField_BorderStyle: solid;
    --sapField_BorderCornerRadius: 0;
    --sapField_Shadow: none;
    --sapField_Hover_Background: light-dark(#fff, #000);
    --sapField_Hover_BackgroundStyle: none;
    --sapField_Hover_BorderColor: light-dark(#000, #fff);
    --sapField_Hover_HelpBackground: light-dark(#fff, #000);
    --sapField_Hover_Shadow: none;
    --sapField_Hover_InvalidShadow: none;
    --sapField_Hover_WarningShadow: none;
    --sapField_Hover_SuccessShadow: none;
    --sapField_Hover_InformationShadow: none;
    --sapField_Active_BorderColor: light-dark(#000, #fff);
    --sapField_Focus_Background: light-dark(#fff, #000);
    --sapField_Focus_BorderColor: light-dark(#000, #fff);
    --sapField_Focus_HelpBackground: light-dark(#fff, #000);
    --sapField_ReadOnly_Background: light-dark(#b3b3b3, #585858);
    --sapField_ReadOnly_BackgroundStyle: none;
    --sapField_ReadOnly_BorderColor: light-dark(#000, #fff);
    --sapField_ReadOnly_BorderStyle: solid;
    --sapField_ReadOnly_HelpBackground: light-dark(#b3b3b3, #585858);
    --sapField_RequiredColor: light-dark(#000, #fff);
    --sapField_InvalidColor: light-dark(#000, #fff);
    --sapField_InvalidBackground: light-dark(#e97624, #795100);
    --sapField_InvalidBackgroundStyle: none;
    --sapField_InvalidBorderWidth: .125rem;
    --sapField_InvalidBorderStyle: dashed;
    --sapField_InvalidShadow: none;
    --sapField_WarningColor: light-dark(#000, #fff);
    --sapField_WarningBackground: light-dark(#fff, #000);
    --sapField_WarningBackgroundStyle: none;
    --sapField_WarningBorderWidth: .125rem;
    --sapField_WarningBorderStyle: dashed;
    --sapField_WarningShadow: none;
    --sapField_SuccessColor: light-dark(#000, #fff);
    --sapField_SuccessBackground: light-dark(#fff, #000);
    --sapField_SuccessBackgroundStyle: none;
    --sapField_SuccessBorderWidth: .125rem;
    --sapField_SuccessBorderStyle: solid;
    --sapField_SuccessShadow: none;
    --sapField_InformationColor: light-dark(#000, #fff);
    --sapField_InformationBackground: light-dark(#fff, #000);
    --sapField_InformationBackgroundStyle: none;
    --sapField_InformationBorderWidth: .0625rem;
    --sapField_InformationBorderStyle: dashed;
    --sapField_InformationShadow: none;
    --sapField_Selector_Hover_Background: light-dark(#5c93ff, #0f5c93);
    --sapField_Selector_Hover_InvalidBackground: light-dark(#e97624, #795100);
    --sapField_Selector_Hover_WarningBackground: light-dark(#fff, #000);
    --sapField_Selector_Hover_SuccessBackground: light-dark(#fff, #000);
    --sapField_Selector_Hover_InformationBackground: light-dark(#fff, #000);
    --sapField_Picker_BorderColor: light-dark(#fff, #000);
    --sapField_Picker_BorderWidth: .125rem;
    --sapField_Selector_BorderStyle: solid;
    --sapField_Selector_ReadOnly_BorderStyle: solid;
    --sapField_Selector_InvalidBorderStyle: dashed;
    --sapField_Selector_WarningBorderStyle: dashed;
    --sapField_Selector_SuccessBorderStyle: solid;
    --sapField_Selector_InformationBorderStyle: dashed;
    --sapGroup_TitleBorderWidth: .125rem;
    --sapGroup_TitleBackground: light-dark(#fff, #000);
    --sapGroup_TitleBorderColor: light-dark(#000, #fff);
    --sapGroup_TitleTextColor: light-dark(#000, #fff);
    --sapGroup_Title_FontSize: 1rem;
    --sapGroup_ContentBackground: light-dark(#fff, #000);
    --sapGroup_ContentBorderColor: light-dark(#000, #fff);
    --sapGroup_BorderWidth: .0625rem;
    --sapGroup_BorderCornerRadius: 0;
    --sapGroup_FooterBackground: light-dark(#fff, #000);
    --sapToolbar_Background: light-dark(#fff, #000);
    --sapToolbar_SeparatorColor: light-dark(#000, #fff);
    --sapList_HeaderBackground: light-dark(#fff, #000);
    --sapList_HeaderBorderColor: light-dark(#000, #fff);
    --sapList_HeaderTextColor: light-dark(#000, #fff);
    --sapList_BorderColor: light-dark(#585858, #999);
    --sapList_BorderWidth: .0625rem;
    --sapList_TextColor: light-dark(#000, #fff);
    --sapList_Active_TextColor: light-dark(#000, #fff);
    --sapList_Active_Background: light-dark(#e97624, #795100);
    --sapList_SelectionBackgroundColor: light-dark(#5c93ff, #0f5c93);
    --sapList_SelectionBorderColor: light-dark(#000, #fff);
    --sapList_Hover_SelectionBackground: light-dark(#e97624, #795100);
    --sapList_Background: light-dark(#fff, #000);
    --sapList_Hover_Background: light-dark(#e97624, #795100);
    --sapList_AlternatingBackground: light-dark(#e6e6e6, #262626);
    --sapList_GroupHeaderBackground: light-dark(#fff, #000);
    --sapList_GroupHeaderBorderColor: light-dark(#000, #fff);
    --sapList_GroupHeaderTextColor: light-dark(#000, #fff);
    --sapList_TableGroupHeaderBackground: light-dark(#b3b3b3, #585858);
    --sapList_TableGroupHeaderBorderColor: light-dark(#000, #fff);
    --sapList_TableGroupHeaderTextColor: light-dark(#000, #fff);
    --sapList_FooterBackground: light-dark(#fff, #000);
    --sapList_FooterTextColor: light-dark(#000, #fff);
    --sapList_TableFooterBorder: light-dark(#000, #fff);
    --sapList_TableFixedBorderColor: light-dark(#000, #fff);
    --sapList_TableFixedColumnBorderWidth: .1875rem;
    --sapList_TableFixedRowBorderWidth: .1875rem;
    --sapMessage_BorderWidth: .125rem;
    --sapMessage_ErrorBorderColor: light-dark(#ab0000, #ff5e5e);
    --sapMessage_WarningBorderColor: light-dark(#5c5c00, #ffab1d);
    --sapMessage_SuccessBorderColor: light-dark(#006362, #99cc99);
    --sapMessage_InformationBorderColor: light-dark(#000, #fff);
    --sapMessage_Button_Hover_Background: light-dark(#e97624, #795100);
    --sapPopover_BorderCornerRadius: .25rem;
    --sapProgress_Background: light-dark(#fff, #000);
    --sapProgress_BorderColor: light-dark(#000, #fff);
    --sapProgress_TextColor: light-dark(#000, #fff);
    --sapProgress_FontSize: .875rem;
    --sapProgress_NegativeBackground: light-dark(#fff, #000);
    --sapProgress_NegativeBorderColor: light-dark(#000, #fff);
    --sapProgress_NegativeTextColor: light-dark(#000, #fff);
    --sapProgress_CriticalBackground: light-dark(#fff, #000);
    --sapProgress_CriticalBorderColor: light-dark(#000, #fff);
    --sapProgress_CriticalTextColor: light-dark(#000, #fff);
    --sapProgress_PositiveBackground: light-dark(#fff, #000);
    --sapProgress_PositiveBorderColor: light-dark(#000, #fff);
    --sapProgress_PositiveTextColor: light-dark(#000, #fff);
    --sapProgress_InformationBackground: light-dark(#fff, #000);
    --sapProgress_InformationBorderColor: light-dark(#000, #fff);
    --sapProgress_InformationTextColor: light-dark(#000, #fff);
    --sapProgress_Value_Background: light-dark(#e97624, #795100);
    --sapProgress_Value_BorderColor: light-dark(#000, #fff);
    --sapProgress_Value_TextColor: light-dark(#000, #fff);
    --sapProgress_Value_NegativeBackground: light-dark(#e97624, #795100);
    --sapProgress_Value_NegativeBorderColor: light-dark(#000, #fff);
    --sapProgress_Value_NegativeTextColor: light-dark(#000, #fff);
    --sapProgress_Value_CriticalBackground: light-dark(#e97624, #795100);
    --sapProgress_Value_CriticalBorderColor: light-dark(#000, #fff);
    --sapProgress_Value_CriticalTextColor: light-dark(#000, #fff);
    --sapProgress_Value_PositiveBackground: light-dark(#e97624, #795100);
    --sapProgress_Value_PositiveBorderColor: light-dark(#000, #fff);
    --sapProgress_Value_PositiveTextColor: light-dark(#000, #fff);
    --sapProgress_Value_InformationBackground: light-dark(#e97624, #795100);
    --sapProgress_Value_InformationBorderColor: light-dark(#000, #fff);
    --sapProgress_Value_InformationTextColor: light-dark(#000, #fff);
    --sapScrollBar_FaceColor: light-dark(#585858, #999);
    --sapScrollBar_TrackColor: light-dark(#fff, #000);
    --sapScrollBar_BorderColor: light-dark(#585858, #999);
    --sapScrollBar_SymbolColor: light-dark(#000, #fff);
    --sapScrollBar_Dimension: .75rem;
    --sapScrollBar_Hover_FaceColor: light-dark(#000, #fff);
    --sapSlider_Background: light-dark(#fff, #000);
    --sapSlider_BorderColor: light-dark(#000, #fff);
    --sapSlider_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapSlider_Selected_BorderColor: light-dark(#000, #fff);
    --sapSlider_Selected_Dimension: .25rem;
    --sapSlider_HandleBackground: light-dark(#fff, #000);
    --sapSlider_HandleBorderColor: light-dark(#000, #fff);
    --sapSlider_RangeHandleBackground: light-dark(#fff, #000);
    --sapSlider_Hover_HandleBackground: light-dark(#e97624, #795100);
    --sapSlider_Hover_HandleBorderColor: light-dark(#000, #fff);
    --sapSlider_Hover_RangeHandleBackground: light-dark(#e97624, #795100);
    --sapSlider_Active_HandleBackground: light-dark(#e97624, #795100);
    --sapSlider_Active_HandleBorderColor: light-dark(#000, #fff);
    --sapSlider_Active_RangeHandleBackground: transparent;
    --sapPageHeader_Background: light-dark(#fff, #000);
    --sapPageHeader_BorderColor: light-dark(#000, #fff);
    --sapPageHeader_TextColor: light-dark(#000, #fff);
    --sapPageFooter_Background: light-dark(#fff, #000);
    --sapPageFooter_BorderColor: light-dark(#000, #fff);
    --sapPageFooter_TextColor: light-dark(#000, #fff);
    --sapInfobar_Background: light-dark(#fff, #000);
    --sapInfobar_Hover_Background: light-dark(#e97624, #795100);
    --sapInfobar_Active_Background: light-dark(#e97624, #795100);
    --sapInfobar_NonInteractive_Background: light-dark(#b3b3b3, #585858);
    --sapInfobar_TextColor: light-dark(#000, #fff);
    --sapObjectHeader_Background: light-dark(#fff, #000);
    --sapObjectHeader_Hover_Background: light-dark(#e97624, #795100);
    --sapObjectHeader_BorderColor: light-dark(#000, #fff);
    --sapObjectHeader_Title_TextColor: light-dark(#000, #fff);
    --sapObjectHeader_Title_FontSize: 1.5rem;
    --sapObjectHeader_Title_SnappedFontSize: 1.25rem;
    --sapObjectHeader_Title_FontFamily: "72-Bold", "72-Boldfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapObjectHeader_Subtitle_TextColor: light-dark(#000, #fff);
    --sapBlockLayer_Background: light-dark(#fff, #000);
    --sapBlockLayer_Opacity: .3;
    --sapTab_TextColor: light-dark(#000, #fff);
    --sapTab_ForegroundColor: light-dark(#000, #fff);
    --sapTab_IconColor: light-dark(#000, #fff);
    --sapTab_Background: light-dark(#fff, #000);
    --sapTab_Selected_TextColor: light-dark(#000, #fff);
    --sapTab_Selected_IconColor: light-dark(#000, #fff);
    --sapTab_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapTab_Selected_Indicator_Dimension: .3125rem;
    --sapTab_Positive_TextColor: light-dark(#000, #fff);
    --sapTab_Positive_ForegroundColor: light-dark(#000, #fff);
    --sapTab_Positive_IconColor: light-dark(#000, #fff);
    --sapTab_Positive_Selected_TextColor: light-dark(#000, #fff);
    --sapTab_Positive_Selected_IconColor: light-dark(#000, #fff);
    --sapTab_Positive_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapTab_Negative_TextColor: light-dark(#000, #fff);
    --sapTab_Negative_ForegroundColor: light-dark(#000, #fff);
    --sapTab_Negative_IconColor: light-dark(#000, #fff);
    --sapTab_Negative_Selected_TextColor: light-dark(#000, #fff);
    --sapTab_Negative_Selected_IconColor: light-dark(#000, #fff);
    --sapTab_Negative_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapTab_Critical_TextColor: light-dark(#000, #fff);
    --sapTab_Critical_ForegroundColor: light-dark(#000, #fff);
    --sapTab_Critical_IconColor: light-dark(#000, #fff);
    --sapTab_Critical_Selected_TextColor: light-dark(#000, #fff);
    --sapTab_Critical_Selected_IconColor: light-dark(#000, #fff);
    --sapTab_Critical_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapTab_Neutral_TextColor: light-dark(#000, #fff);
    --sapTab_Neutral_ForegroundColor: light-dark(#000, #fff);
    --sapTab_Neutral_IconColor: light-dark(#000, #fff);
    --sapTab_Neutral_Selected_TextColor: light-dark(#000, #fff);
    --sapTab_Neutral_Selected_IconColor: light-dark(#000, #fff);
    --sapTab_Neutral_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapTile_Background: light-dark(#fff, #000);
    --sapTile_Hover_Background: light-dark(#e97624, #795100);
    --sapTile_Active_Background: light-dark(#e97624, #795100);
    --sapTile_BorderColor: light-dark(#000, #fff);
    --sapTile_BorderCornerRadius: .25rem;
    --sapTile_TitleTextColor: light-dark(#000, #fff);
    --sapTile_TextColor: light-dark(#000, #fff);
    --sapTile_IconColor: light-dark(#000, #fff);
    --sapTile_SeparatorColor: transparent;
    --sapTile_Interactive_BorderColor: light-dark(#000, #fff);
    --sapTile_OverlayBackground: light-dark(#fff, #000);
    --sapTile_OverlayForegroundColor: light-dark(#000, #fff);
    --sapTile_Hover_ContentBackground: light-dark(#e97624, #795100);
    --sapTile_Active_ContentBackground: light-dark(#e97624, #795100);
    --sapAccentColor1: light-dark(#5f5800, #ffc847);
    --sapAccentColor2: light-dark(#5e4101, #ed884a);
    --sapAccentColor3: light-dark(#973333, #db9292);
    --sapAccentColor4: light-dark(#961d7c, #e269c9);
    --sapAccentColor5: light-dark(#365892, #8ca7d5);
    --sapAccentColor6: light-dark(#004ccb, #6bd3ff);
    --sapAccentColor7: light-dark(#105b5b, #7fc6c6);
    --sapAccentColor8: light-dark(#26340b, #b2e484);
    --sapAccentColor9: light-dark(#6c32a9, #b995e0);
    --sapAccentColor10: light-dark(#4a5964, #b0bcc5);
    --sapAccentBackgroundColor1: light-dark(#fff, #000);
    --sapAccentBackgroundColor2: light-dark(#fff, #000);
    --sapAccentBackgroundColor3: light-dark(#fff, #000);
    --sapAccentBackgroundColor4: light-dark(#fff, #000);
    --sapAccentBackgroundColor5: light-dark(#fff, #000);
    --sapAccentBackgroundColor6: light-dark(#fff, #000);
    --sapAccentBackgroundColor7: light-dark(#fff, #000);
    --sapAccentBackgroundColor8: light-dark(#fff, #000);
    --sapAccentBackgroundColor9: light-dark(#fff, #000);
    --sapAccentBackgroundColor10: light-dark(#fff, #000);
    --sapIndicationColor_1: light-dark(#780000, #ff5e5e);
    --sapIndicationColor_1_Background: light-dark(#fff, #000);
    --sapIndicationColor_1_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_1_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_1_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_1_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_1_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_1_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_1_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_1_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_1_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_1b: light-dark(#780000, #ff5e5e);
    --sapIndicationColor_1b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_1b_Background: light-dark(#fff, #000);
    --sapIndicationColor_1b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_1b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_2: light-dark(#ab0000, #ff9191);
    --sapIndicationColor_2_Background: light-dark(#fff, #000);
    --sapIndicationColor_2_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_2_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_2_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_2_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_2_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_2_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_2_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_2_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_2_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_2b: light-dark(#ab0000, #ff9191);
    --sapIndicationColor_2b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_2b_Background: light-dark(#fff, #000);
    --sapIndicationColor_2b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_2b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_3: light-dark(#5c5c00, #ffab1d);
    --sapIndicationColor_3_Background: light-dark(#fff, #000);
    --sapIndicationColor_3_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_3_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_3_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_3_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_3_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_3_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_3_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_3_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_3_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_3b: light-dark(#5c5c00, #ffab1d);
    --sapIndicationColor_3b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_3b_Background: light-dark(#fff, #000);
    --sapIndicationColor_3b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_3b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_4: light-dark(#006362, #99cc99);
    --sapIndicationColor_4_Background: light-dark(#fff, #000);
    --sapIndicationColor_4_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_4_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_4_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_4_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_4_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_4_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_4_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_4_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_4_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_4b: light-dark(#006362, #99cc99);
    --sapIndicationColor_4b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_4b_Background: light-dark(#fff, #000);
    --sapIndicationColor_4b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_4b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_5: light-dark(#004ccb, #6bd3ff);
    --sapIndicationColor_5_Background: light-dark(#fff, #000);
    --sapIndicationColor_5_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_5_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_5_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_5_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_5_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_5_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_5_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_5_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_5_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_5b: light-dark(#004ccb, #6bd3ff);
    --sapIndicationColor_5b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_5b_Background: light-dark(#fff, #000);
    --sapIndicationColor_5b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_5b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_6: light-dark(#105b5b, #7fc6c6);
    --sapIndicationColor_6_Background: light-dark(#fff, #000);
    --sapIndicationColor_6_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_6_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_6_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_6_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_6_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_6_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_6_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_6_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_6_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_6b: light-dark(#105b5b, #7fc6c6);
    --sapIndicationColor_6b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_6b_Background: light-dark(#fff, #000);
    --sapIndicationColor_6b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_6b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_7: light-dark(#6c32a9, #b995e0);
    --sapIndicationColor_7_Background: light-dark(#fff, #000);
    --sapIndicationColor_7_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_7_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_7_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_7_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_7_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_7_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_7_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_7_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_7_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_7b: light-dark(#6c32a9, #b995e0);
    --sapIndicationColor_7b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_7b_Background: light-dark(#fff, #000);
    --sapIndicationColor_7b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_7b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_8: light-dark(#961d7c, #e269c9);
    --sapIndicationColor_8_Background: light-dark(#fff, #000);
    --sapIndicationColor_8_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_8_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_8_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_8_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_8_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_8_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_8_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_8_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_8_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_8b: light-dark(#961d7c, #e269c9);
    --sapIndicationColor_8b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_8b_Background: light-dark(#fff, #000);
    --sapIndicationColor_8b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_8b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_9: light-dark(#fff, #000);
    --sapIndicationColor_9_Background: light-dark(#fff, #000);
    --sapIndicationColor_9_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_9_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_9_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_9_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_9_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_9_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_9_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_9_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_9_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_9b: light-dark(#fff, #000);
    --sapIndicationColor_9b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_9b_Background: light-dark(#fff, #000);
    --sapIndicationColor_9b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_9b_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_10: light-dark(#eaecee, #494949);
    --sapIndicationColor_10_Background: light-dark(#fff, #000);
    --sapIndicationColor_10_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_10_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_10_Hover_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_10_Active_Background: light-dark(#e97624, #795100);
    --sapIndicationColor_10_Active_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_10_Active_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_10_Selected_Background: light-dark(#5c93ff, #0f5c93);
    --sapIndicationColor_10_Selected_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_10_Selected_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_10b: light-dark(#eaecee, #494949);
    --sapIndicationColor_10b_TextColor: light-dark(#000, #fff);
    --sapIndicationColor_10b_Background: light-dark(#fff, #000);
    --sapIndicationColor_10b_BorderColor: light-dark(#000, #fff);
    --sapIndicationColor_10b_Hover_Background: light-dark(#e97624, #795100);
    --sapLegend_WorkingBackground: light-dark(#d9d9d9, #2e2e2e);
    --sapLegend_NonWorkingBackground: light-dark(#b3b3b3, #585858);
    --sapLegend_CurrentDateTime: light-dark(#961d7c, #e269c9);
    --sapLegendColor1: light-dark(#5f5800, #ffc847);
    --sapLegendColor2: light-dark(#5e4101, #ed884a);
    --sapLegendColor3: light-dark(#973333, #db9292);
    --sapLegendColor4: light-dark(#463000, #ff741f);
    --sapLegendColor5: light-dark(#961d7c, #e269c9);
    --sapLegendColor6: light-dark(#004ccb, #6bd3ff);
    --sapLegendColor7: light-dark(#105b5b, #7fc6c6);
    --sapLegendColor8: light-dark(#26340b, #b2e484);
    --sapLegendColor9: light-dark(#4a5964, #b0bcc5);
    --sapLegendColor10: light-dark(#6c3d62, #bb86b0);
    --sapLegendColor11: light-dark(#383513, #ffe6ad);
    --sapLegendColor12: light-dark(#734f00, #cdaf9d);
    --sapLegendColor13: light-dark(#723e3e, #ff8787);
    --sapLegendColor14: light-dark(#5f5642, #ffb385);
    --sapLegendColor15: light-dark(#60535d, #ffb2ef);
    --sapLegendColor16: light-dark(#465878, #9cabc5);
    --sapLegendColor17: light-dark(#435b5b, #a4eeee);
    --sapLegendColor18: light-dark(#4e5a36, #8d9e7e);
    --sapLegendColor19: light-dark(#4e5869, #addcf0);
    --sapLegendColor20: light-dark(#001b49, #629cff);
    --sapLegendBackgroundColor1: light-dark(#fff, #000);
    --sapLegendBackgroundColor2: light-dark(#fff, #000);
    --sapLegendBackgroundColor3: light-dark(#fff, #000);
    --sapLegendBackgroundColor4: light-dark(#fff, #000);
    --sapLegendBackgroundColor5: light-dark(#fff, #000);
    --sapLegendBackgroundColor6: light-dark(#fff, #000);
    --sapLegendBackgroundColor7: light-dark(#fff, #000);
    --sapLegendBackgroundColor8: light-dark(#fff, #000);
    --sapLegendBackgroundColor9: light-dark(#fff, #000);
    --sapLegendBackgroundColor10: light-dark(#fff, #000);
    --sapLegendBackgroundColor11: light-dark(#fff, #000);
    --sapLegendBackgroundColor12: light-dark(#fff, #000);
    --sapLegendBackgroundColor13: light-dark(#fff, #000);
    --sapLegendBackgroundColor14: light-dark(#fff, #000);
    --sapLegendBackgroundColor15: light-dark(#fff, #000);
    --sapLegendBackgroundColor16: light-dark(#fff, #000);
    --sapLegendBackgroundColor17: light-dark(#fff, #000);
    --sapLegendBackgroundColor18: light-dark(#fff, #000);
    --sapLegendBackgroundColor19: light-dark(#fff, #000);
    --sapLegendBackgroundColor20: light-dark(#fff, #000);
    --sapChart_Background: light-dark(#fff, #000);
    --sapChart_ContrastTextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_ContrastShadowColor: light-dark(#fff, #000);
    --sapChart_ContrastLineColor: light-dark(#fff, #000);
    --sapChart_LineColor_1: light-dark(#888, #666);
    --sapChart_LineColor_2: light-dark(#000, #fff);
    --sapChart_LineColor_3: light-dark(#000, #fff);
    --sapChart_Choropleth_Background: light-dark(#b3b3b3, #585858);
    --sapChart_ChoroplethRegion_Background: light-dark(#525252, #afafaf);
    --sapChart_ChoroplethRegion_BorderColor: light-dark(#b3b3b3, #585858);
    --sapChart_Data_TextColor: light-dark(#000, #fff);
    --sapChart_Data_ContrastTextColor: light-dark(#fff, #000);
    --sapChart_Data_InteractiveColor: light-dark(#000, #fff);
    --sapChart_Data_Active_Background: light-dark(#e97624, #795100);
    --sapChart_IBCS_Actual: light-dark(#000, #f9f9f9);
    --sapChart_IBCS_Previous: light-dark(#525252, #969696);
    --sapChart_IBCS_Good: light-dark(#006362, #99cc99);
    --sapChart_IBCS_Bad: light-dark(#ab0000, #ff7878);
    --sapChart_OrderedColor_1: light-dark(#446e97, #8babcb);
    --sapChart_OrderedColor_2: light-dark(#d74114, #ed8859);
    --sapChart_OrderedColor_3: light-dark(#2d6f51, #9fb822);
    --sapChart_OrderedColor_4: light-dark(#df1278, #fe74ae);
    --sapChart_OrderedColor_5: light-dark(#7d44cf, #c092f6);
    --sapChart_OrderedColor_6: light-dark(#03778c, #05c0ba);
    --sapChart_OrderedColor_7: light-dark(#0070f2, #05c0ba);
    --sapChart_OrderedColor_8: light-dark(#ae478d, #f473f0);
    --sapChart_OrderedColor_9: light-dark(#667664, #9dad9b);
    --sapChart_OrderedColor_10: light-dark(#b75757, #f28585);
    --sapChart_OrderedColor_11: light-dark(#4b25e7, #9ea3f6);
    --sapChart_OrderedColor_12: light-dark(#816246, #b49e78);
    --sapChart_Bad: light-dark(#ab0000, #ff7878);
    --sapChart_Critical: light-dark(#5c5c00, #ffab1d);
    --sapChart_Good: light-dark(#006362, #99cc99);
    --sapChart_Neutral: light-dark(#525252, #afafaf);
    --sapChart_Sequence_1_Plus3: light-dark(#6f97be, #d1deeb);
    --sapChart_Sequence_1_Plus3_TextColor: #000;
    --sapChart_Sequence_1_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_1_Plus2: light-dark(#5a88b4, #b5cade);
    --sapChart_Sequence_1_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_1_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_1_Plus1: light-dark(#4c7ba9, #a4bdd6);
    --sapChart_Sequence_1_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_1_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_1: light-dark(#446e97, #8babcb);
    --sapChart_Sequence_1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_1_BorderColor: light-dark(#446e97, #8babcb);
    --sapChart_Sequence_1_Minus1: light-dark(#3c6185, #7299c0);
    --sapChart_Sequence_1_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_1_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_1_Minus2: light-dark(#345474, #3a5e83);
    --sapChart_Sequence_1_Minus2_TextColor: #fff;
    --sapChart_Sequence_1_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_1_Minus3: light-dark(#2c4862, #2b455f);
    --sapChart_Sequence_1_Minus3_TextColor: #fff;
    --sapChart_Sequence_1_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_1_Minus4: light-dark(#243b51, #23384e);
    --sapChart_Sequence_1_Minus4_TextColor: #fff;
    --sapChart_Sequence_1_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_1_Minus5: light-dark(#1c2e3f, #1b2b3c);
    --sapChart_Sequence_1_Minus5_TextColor: #fff;
    --sapChart_Sequence_1_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_2_Plus3: light-dark(#ee6c45, #fdd9c8);
    --sapChart_Sequence_2_Plus3_TextColor: #000;
    --sapChart_Sequence_2_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_2_Plus2: light-dark(#ec5d32, #f9bfa4);
    --sapChart_Sequence_2_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_2_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_2_Plus1: light-dark(#ea4b1b, #f3a27b);
    --sapChart_Sequence_2_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_2_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_2: light-dark(#d74114, #ed8859);
    --sapChart_Sequence_2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_2_BorderColor: light-dark(#d74114, #ed8859);
    --sapChart_Sequence_2_Minus1: light-dark(#c03a12, #e9743f);
    --sapChart_Sequence_2_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_2_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_2_Minus2: light-dark(#9f300f, #9c3d11);
    --sapChart_Sequence_2_Minus2_TextColor: #fff;
    --sapChart_Sequence_2_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_2_Minus3: light-dark(#912c0d, #80320e);
    --sapChart_Sequence_2_Minus3_TextColor: #fff;
    --sapChart_Sequence_2_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_2_Minus4: light-dark(#7a250b, #65270b);
    --sapChart_Sequence_2_Minus4_TextColor: #fff;
    --sapChart_Sequence_2_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_2_Minus5: light-dark(#621e09, #973b10);
    --sapChart_Sequence_2_Minus5_TextColor: #fff;
    --sapChart_Sequence_2_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_3_Plus3: light-dark(#43a579, #cdd5a3);
    --sapChart_Sequence_3_Plus3_TextColor: #000;
    --sapChart_Sequence_3_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_3_Plus2: light-dark(#3c936b, #b8c47c);
    --sapChart_Sequence_3_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_3_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_3_Plus1: light-dark(#34815e, #a9ba53);
    --sapChart_Sequence_3_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_3_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_3: light-dark(#2d6f51, #9fb822);
    --sapChart_Sequence_3_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_3_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_3_BorderColor: light-dark(#2d6f51, #9fb822);
    --sapChart_Sequence_3_Minus1: light-dark(#265d44, #8aa115);
    --sapChart_Sequence_3_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_3_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_3_Minus2: light-dark(#1e4b37, #5c6b14);
    --sapChart_Sequence_3_Minus2_TextColor: #fff;
    --sapChart_Sequence_3_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_3_Minus3: light-dark(#183c2c, #3e480d);
    --sapChart_Sequence_3_Minus3_TextColor: #fff;
    --sapChart_Sequence_3_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_3_Minus4: light-dark(#132e21, #333b0b);
    --sapChart_Sequence_3_Minus4_TextColor: #fff;
    --sapChart_Sequence_3_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_3_Minus5: light-dark(#0d1f17, #282e09);
    --sapChart_Sequence_3_Minus5_TextColor: #fff;
    --sapChart_Sequence_3_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_4_Plus3: light-dark(#f25ba6, #ffd9e9);
    --sapChart_Sequence_4_Plus3_TextColor: #000;
    --sapChart_Sequence_4_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_4_Plus2: light-dark(#ef3a94, #ffc0da);
    --sapChart_Sequence_4_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_4_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_4_Plus1: light-dark(#ed2287, #fe97c3);
    --sapChart_Sequence_4_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_4_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_4: light-dark(#df1278, #fe74ae);
    --sapChart_Sequence_4_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_4_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_4_BorderColor: light-dark(#df1278, #fe74ae);
    --sapChart_Sequence_4_Minus1: light-dark(#c7106b, #f95a9e);
    --sapChart_Sequence_4_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_4_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_4_Minus2: light-dark(#b00e5f, #b4014c);
    --sapChart_Sequence_4_Minus2_TextColor: #fff;
    --sapChart_Sequence_4_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_4_Minus3: light-dark(#980c52, #9b0142);
    --sapChart_Sequence_4_Minus3_TextColor: #fff;
    --sapChart_Sequence_4_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_4_Minus4: light-dark(#810a45, #860139);
    --sapChart_Sequence_4_Minus4_TextColor: #fff;
    --sapChart_Sequence_4_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_4_Minus5: light-dark(#690839, #720130);
    --sapChart_Sequence_4_Minus5_TextColor: #fff;
    --sapChart_Sequence_4_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_5_Plus3: light-dark(#a781df, #e9d9fc);
    --sapChart_Sequence_5_Plus3_TextColor: #000;
    --sapChart_Sequence_5_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_5_Plus2: light-dark(#996dd9, #dbc1fa);
    --sapChart_Sequence_5_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_5_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_5_Plus1: light-dark(#8b58d4, #ceaaf8);
    --sapChart_Sequence_5_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_5_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_5: light-dark(#7d44cf, #c092f6);
    --sapChart_Sequence_5_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_5_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_5_BorderColor: light-dark(#7d44cf, #c092f6);
    --sapChart_Sequence_5_Minus1: light-dark(#6f33c7, #b37bf4);
    --sapChart_Sequence_5_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_5_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_5_Minus2: light-dark(#642eb2, #7927d8);
    --sapChart_Sequence_5_Minus2_TextColor: #fff;
    --sapChart_Sequence_5_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_5_Minus3: light-dark(#59299e, #6320b1);
    --sapChart_Sequence_5_Minus3_TextColor: #fff;
    --sapChart_Sequence_5_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_5_Minus4: light-dark(#522592, #541b97);
    --sapChart_Sequence_5_Minus4_TextColor: #fff;
    --sapChart_Sequence_5_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_5_Minus5: light-dark(#492182, #371263);
    --sapChart_Sequence_5_Minus5_TextColor: #fff;
    --sapChart_Sequence_5_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_6_Plus3: light-dark(#04a1be, #73ebe7);
    --sapChart_Sequence_6_Plus3_TextColor: #000;
    --sapChart_Sequence_6_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_6_Plus2: light-dark(#0495af, #47e4e0);
    --sapChart_Sequence_6_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_6_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_6_Plus1: light-dark(#0388a0, #1fd9d3);
    --sapChart_Sequence_6_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_6_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_6: light-dark(#03778c, #05c0ba);
    --sapChart_Sequence_6_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_6_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_6_BorderColor: light-dark(#03778c, #05c0ba);
    --sapChart_Sequence_6_Minus1: light-dark(#036678, #04a7a2);
    --sapChart_Sequence_6_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_6_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_6_Minus2: light-dark(#025564, #006562);
    --sapChart_Sequence_6_Minus2_TextColor: #fff;
    --sapChart_Sequence_6_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_6_Minus3: light-dark(#024450, #004b48);
    --sapChart_Sequence_6_Minus3_TextColor: #fff;
    --sapChart_Sequence_6_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_6_Minus4: light-dark(#01333c, #003635);
    --sapChart_Sequence_6_Minus4_TextColor: #fff;
    --sapChart_Sequence_6_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_6_Minus5: light-dark(#012228, #002c2b);
    --sapChart_Sequence_6_Minus5_TextColor: #fff;
    --sapChart_Sequence_6_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_7_Plus3: light-dark(#3a95ff, #19f9f2);
    --sapChart_Sequence_7_Plus3_TextColor: #000;
    --sapChart_Sequence_7_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_7_Plus2: light-dark(#268aff, #06f2ea);
    --sapChart_Sequence_7_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_7_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_7_Plus1: light-dark(#0d7dff, #06d9d2);
    --sapChart_Sequence_7_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_7_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_7: light-dark(#0070f2, #05c0ba);
    --sapChart_Sequence_7_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_7_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_7_BorderColor: light-dark(#0070f2, #05c0ba);
    --sapChart_Sequence_7_Minus1: light-dark(#0062d3, #04a7a2);
    --sapChart_Sequence_7_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_7_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_7_Minus2: light-dark(#0054b5, #012b2a);
    --sapChart_Sequence_7_Minus2_TextColor: #fff;
    --sapChart_Sequence_7_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_7_Minus3: light-dark(#00418c, #000);
    --sapChart_Sequence_7_Minus3_TextColor: #fff;
    --sapChart_Sequence_7_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_7_Minus4: light-dark(#00244f, #000);
    --sapChart_Sequence_7_Minus4_TextColor: #fff;
    --sapChart_Sequence_7_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_7_Minus5: light-dark(#001b3a, #000);
    --sapChart_Sequence_7_Minus5_TextColor: #fff;
    --sapChart_Sequence_7_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_8_Plus3: light-dark(#c879af, #fed9fd);
    --sapChart_Sequence_8_Plus3_TextColor: #000;
    --sapChart_Sequence_8_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_8_Plus2: light-dark(#c167a4, #fabff8);
    --sapChart_Sequence_8_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_8_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_8_Plus1: light-dark(#ba5599, #f8a2f5);
    --sapChart_Sequence_8_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_8_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_8: light-dark(#ae478d, #f473f0);
    --sapChart_Sequence_8_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_8_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_8_BorderColor: light-dark(#ae478d, #f473f0);
    --sapChart_Sequence_8_Minus1: light-dark(#9c407e, #f14dec);
    --sapChart_Sequence_8_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_8_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_8_Minus2: light-dark(#8a3870, #a2039c);
    --sapChart_Sequence_8_Minus2_TextColor: #fff;
    --sapChart_Sequence_8_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_8_Minus3: light-dark(#783161, #d904d2);
    --sapChart_Sequence_8_Minus3_TextColor: #fff;
    --sapChart_Sequence_8_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_8_Minus4: light-dark(#662952, #c004b9);
    --sapChart_Sequence_8_Minus4_TextColor: #fff;
    --sapChart_Sequence_8_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_8_Minus5: light-dark(#532244, #a2039c);
    --sapChart_Sequence_8_Minus5_TextColor: #fff;
    --sapChart_Sequence_8_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_9_Plus3: light-dark(#879785, #c6cfc5);
    --sapChart_Sequence_9_Plus3_TextColor: #000;
    --sapChart_Sequence_9_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_9_Plus2: light-dark(#7c8e7a, #b8c4b7);
    --sapChart_Sequence_9_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_9_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_9_Plus1: light-dark(#70816d, #abb8a9);
    --sapChart_Sequence_9_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_9_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_9: light-dark(#667664, #9dad9b);
    --sapChart_Sequence_9_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_9_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_9_BorderColor: light-dark(#667664, #9dad9b);
    --sapChart_Sequence_9_Minus1: light-dark(#5c6b5b, #879b85);
    --sapChart_Sequence_9_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_9_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_9_Minus2: light-dark(#536051, #51604f);
    --sapChart_Sequence_9_Minus2_TextColor: #fff;
    --sapChart_Sequence_9_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_9_Minus3: light-dark(#495548, #455243);
    --sapChart_Sequence_9_Minus3_TextColor: #fff;
    --sapChart_Sequence_9_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_9_Minus4: light-dark(#404a3f, #394438);
    --sapChart_Sequence_9_Minus4_TextColor: #fff;
    --sapChart_Sequence_9_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_9_Minus5: light-dark(#363f35, #2d362c);
    --sapChart_Sequence_9_Minus5_TextColor: #fff;
    --sapChart_Sequence_9_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_10_Plus3: light-dark(#c98282, #fdd6d6);
    --sapChart_Sequence_10_Plus3_TextColor: #000;
    --sapChart_Sequence_10_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_10_Plus2: light-dark(#c57777, #f9b7b7);
    --sapChart_Sequence_10_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_10_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_10_Plus1: light-dark(#bd6565, #f7a4a4);
    --sapChart_Sequence_10_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_10_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_10: light-dark(#b75757, #f28585);
    --sapChart_Sequence_10_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_10_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_10_BorderColor: light-dark(#b75757, #f28585);
    --sapChart_Sequence_10_Minus1: light-dark(#af4b4b, #e97070);
    --sapChart_Sequence_10_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_10_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_10_Minus2: light-dark(#a04545, #9a3a3a);
    --sapChart_Sequence_10_Minus2_TextColor: #fff;
    --sapChart_Sequence_10_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_10_Minus3: light-dark(#923f3f, #8b3434);
    --sapChart_Sequence_10_Minus3_TextColor: #fff;
    --sapChart_Sequence_10_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_10_Minus4: light-dark(#843939, #752c2c);
    --sapChart_Sequence_10_Minus4_TextColor: #fff;
    --sapChart_Sequence_10_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_10_Minus5: light-dark(#763232, #5f2424);
    --sapChart_Sequence_10_Minus5_TextColor: #fff;
    --sapChart_Sequence_10_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_11_Plus3: light-dark(#967dff, #e4e5fc);
    --sapChart_Sequence_11_Plus3_TextColor: #000;
    --sapChart_Sequence_11_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_11_Plus2: light-dark(#7e5fff, #cdcffa);
    --sapChart_Sequence_11_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_11_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_11_Plus1: light-dark(#5d36ff, #b5b9f8);
    --sapChart_Sequence_11_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_11_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_11: light-dark(#4b25e7, #9ea3f6);
    --sapChart_Sequence_11_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_11_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_11_BorderColor: light-dark(#4b25e7, #9ea3f6);
    --sapChart_Sequence_11_Minus1: light-dark(#3a17cd, #878df4);
    --sapChart_Sequence_11_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_11_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_11_Minus2: light-dark(#3012a8, #6f77f2);
    --sapChart_Sequence_11_Minus2_TextColor: #fff;
    --sapChart_Sequence_11_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_11_Minus3: light-dark(#250e83, #5861f0);
    --sapChart_Sequence_11_Minus3_TextColor: #fff;
    --sapChart_Sequence_11_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_11_Minus4: light-dark(#1d0b68, #4a53ee);
    --sapChart_Sequence_11_Minus4_TextColor: #fff;
    --sapChart_Sequence_11_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_11_Minus5: light-dark(#10063a, #3b44da);
    --sapChart_Sequence_11_Minus5_TextColor: #fff;
    --sapChart_Sequence_11_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_12_Plus3: light-dark(#b08d6e, #d7cbb6);
    --sapChart_Sequence_12_Plus3_TextColor: #000;
    --sapChart_Sequence_12_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_12_Plus2: light-dark(#9f7956, #caba9f);
    --sapChart_Sequence_12_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_12_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_12_Plus1: light-dark(#926f4f, #c1ae8f);
    --sapChart_Sequence_12_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_12_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_12: light-dark(#816246, #b49e78);
    --sapChart_Sequence_12_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_12_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_12_BorderColor: light-dark(#816246, #b49e78);
    --sapChart_Sequence_12_Minus1: light-dark(#74583f, #a58b5e);
    --sapChart_Sequence_12_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_12_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_12_Minus2: light-dark(#674e38, #a08659);
    --sapChart_Sequence_12_Minus2_TextColor: #fff;
    --sapChart_Sequence_12_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_12_Minus3: light-dark(#594430, #89734c);
    --sapChart_Sequence_12_Minus3_TextColor: #fff;
    --sapChart_Sequence_12_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_12_Minus4: light-dark(#4c3a29, #796543);
    --sapChart_Sequence_12_Minus4_TextColor: #fff;
    --sapChart_Sequence_12_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_12_Minus5: light-dark(#3f3022, #68573a);
    --sapChart_Sequence_12_Minus5_TextColor: #fff;
    --sapChart_Sequence_12_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Bad_Plus3: light-dark(#ff5454, #ffdede);
    --sapChart_Sequence_Bad_Plus3_TextColor: #000;
    --sapChart_Sequence_Bad_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_Bad_Plus2: light-dark(#ff2626, #ffbfbf);
    --sapChart_Sequence_Bad_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Bad_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Bad_Plus1: light-dark(#e80000, #ff9c9c);
    --sapChart_Sequence_Bad_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Bad_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Bad: light-dark(#ab0000, #ff7878);
    --sapChart_Sequence_Bad_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Bad_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Bad_BorderColor: light-dark(#ab0000, #ff7878);
    --sapChart_Sequence_Bad_Minus1: light-dark(#970000, #ff5f5f);
    --sapChart_Sequence_Bad_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Bad_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Bad_Minus2: light-dark(#820000, #ff4545);
    --sapChart_Sequence_Bad_Minus2_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Bad_Minus3: light-dark(#6e0000, #fd0000);
    --sapChart_Sequence_Bad_Minus3_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Bad_Minus4: light-dark(#590000, #de0000);
    --sapChart_Sequence_Bad_Minus4_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Bad_Minus5: light-dark(#000, #ba0000);
    --sapChart_Sequence_Bad_Minus5_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Critical_Plus3: light-dark(#990, #ffda9d);
    --sapChart_Sequence_Critical_Plus3_TextColor: #000;
    --sapChart_Sequence_Critical_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_Critical_Plus2: light-dark(#858500, #ffd183);
    --sapChart_Sequence_Critical_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Critical_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Critical_Plus1: light-dark(#707000, #ffb437);
    --sapChart_Sequence_Critical_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Critical_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Critical: light-dark(#5c5c00, #ffab1d);
    --sapChart_Sequence_Critical_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Critical_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Critical_BorderColor: light-dark(#5c5c00, #ffab1d);
    --sapChart_Sequence_Critical_Minus1: light-dark(#525200, #e99200);
    --sapChart_Sequence_Critical_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Critical_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Critical_Minus2: light-dark(#484800, #7e4f00);
    --sapChart_Sequence_Critical_Minus2_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Critical_Minus3: light-dark(#3d3d00, #643f00);
    --sapChart_Sequence_Critical_Minus3_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Critical_Minus4: light-dark(#330, #4b2f00);
    --sapChart_Sequence_Critical_Minus4_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Critical_Minus5: light-dark(#242400, #412900);
    --sapChart_Sequence_Critical_Minus5_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Good_Plus3: light-dark(#00a5a4, #eef6ee);
    --sapChart_Sequence_Good_Plus3_TextColor: #000;
    --sapChart_Sequence_Good_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_Good_Plus2: light-dark(#00918f, #cce6cc);
    --sapChart_Sequence_Good_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Good_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Good_Plus1: light-dark(#007776, #bdb);
    --sapChart_Sequence_Good_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Good_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Good: light-dark(#006362, #99cc99);
    --sapChart_Sequence_Good_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Good_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Good_BorderColor: light-dark(#006362, #99cc99);
    --sapChart_Sequence_Good_Minus1: light-dark(#005453, #7b7);
    --sapChart_Sequence_Good_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Good_Minus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Good_Minus2: light-dark(#044, #5cad5c);
    --sapChart_Sequence_Good_Minus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Good_Minus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Good_Minus3: light-dark(#003535, #4b964b);
    --sapChart_Sequence_Good_Minus3_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Good_Minus3_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Good_Minus4: light-dark(#002625, #428542);
    --sapChart_Sequence_Good_Minus4_TextColor: #fff;
    --sapChart_Sequence_Good_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Good_Minus5: light-dark(#001c1b, #363);
    --sapChart_Sequence_Good_Minus5_TextColor: #fff;
    --sapChart_Sequence_Good_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Neutral_Plus3: light-dark(#8d8d8d, #f9f9f9);
    --sapChart_Sequence_Neutral_Plus3_TextColor: #000;
    --sapChart_Sequence_Neutral_Plus3_TextShadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
    --sapChart_Sequence_Neutral_Plus2: light-dark(#7b7b7b, #e2e2e2);
    --sapChart_Sequence_Neutral_Plus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Neutral_Plus2_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Neutral_Plus1: light-dark(#666, #d5d5d5);
    --sapChart_Sequence_Neutral_Plus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Neutral_Plus1_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Neutral: light-dark(#525252, #afafaf);
    --sapChart_Sequence_Neutral_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_Neutral_TextShadow: var(--_ui5-light-scheme, -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000) var(--_ui5-dark-scheme, -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff);
    --sapChart_Sequence_Neutral_BorderColor: light-dark(#525252, #afafaf);
    --sapChart_Sequence_Neutral_Minus1: light-dark(#3e3e3e, #969696);
    --sapChart_Sequence_Neutral_Minus1_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus1_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Neutral_Minus2: light-dark(#2e2e2e, #909090);
    --sapChart_Sequence_Neutral_Minus2_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus2_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Neutral_Minus3: light-dark(#242424, #818181);
    --sapChart_Sequence_Neutral_Minus3_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus3_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Neutral_Minus4: light-dark(#1a1a1a, #727272);
    --sapChart_Sequence_Neutral_Minus4_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus4_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapChart_Sequence_Neutral_Minus5: light-dark(#000, #5b5b5b);
    --sapChart_Sequence_Neutral_Minus5_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus5_TextShadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;
    --sapBreakpoint_S_Min: 0;
    --sapBreakpoint_M_Min: 600px;
    --sapBreakpoint_L_Min: 1024px;
    --sapBreakpoint_XL_Min: 1440px;
    --sapSapThemeId: var(--_ui5-light-scheme, sap_horizon_hcw) var(--_ui5-dark-scheme, sap_horizon_hcb);
    --sapHighlightTextColor: light-dark(#000, #fff);
    --sapButton_Emphasized_FontWeight: bold;
    --sapShell_BackgroundGradient: var(--_ui5-light-scheme, linear-gradient(to bottom, #fff, #fff)) var(--_ui5-dark-scheme, linear-gradient(to bottom, #000, #000));
    --sapAt: @

}
@media (prefers-color-scheme: dark) {
    :root {
        --_ui5-light-scheme:  ;
        --_ui5-dark-scheme: var(--_ui5-f2d95f8);
        color-scheme: dark}}`